import dotAccess from 'dot-access';

const messages = {
  it: {
    general: {
      fullSearch: 'Filtra Risultati',
      quickSearch: 'Ricerca Veloce',
      advancedSearch: 'Ricerca Avanzata',
      department: 'Reparto',
      activity: 'Attività',
      substance: 'Sostanza',
      close: 'Chiudi',
      add: 'Aggiungi',
      modify: 'Modifica',
      delete: 'Elimina',
      cancel: 'Annulla',
      save: 'Salva',
      view: 'Visualizza',
      confirm: 'Conferma',
      print: 'Stampa',
      export: 'Esporta',
      clear: 'Pulisci',
      enable: 'Abilita',
      disable: 'Disabilita',
      search: 'Cerca',
      duplicate: 'Duplica',
      download: 'Scarica',
      sessionExpired: 'La sessione è scaduta, effettuare di nuovo il login',
      goToLogin: 'Torna al login',
      clearFilters: 'Pulisci filtri di ricerca',
      results: 'Risultato/i',
      success: 'Operazione conclusa con successo',
      confirmDeletion: {
        title: 'Confermare azione?',
        text: 'Confermare cancellazione di questo elemento?',
      },
      acknowlegmentSDShandleAdd: {
        title: 'Confermare la presa visione?',
        text: 'Confermi di voler procedere alla presa visione della SDS per questa sostanza?',
      },
      confirmResend: {
        title: 'Confermare azione?',
        text: 'Confermare il reinvio di questo elemento?',
      },
      signature: {
        title: '',
        text: "Inserisci la password per confermare l'azione",
        input: 'Password',
      },
      dropzone: {
        content: 'Rilascia qui file per caricarli',
        button: 'Scegli file da caricare',
        error: "Errore durante l'upload, il file non è stato caricato",
        rejected: 'Il file non è stato caricato perchè più grande del limite consentito (10MB)',
      },
      noResults: 'Nessun risultato trovato',
      valueChoosing: 'Scegli un valore',
      errorOccurred: 'Si è verificato un errore',
      deleteAssociation: 'Eliminare associazione tra',
      and: 'e',
      andOther: 'e altri',
      of: 'di',
      toggleLocale: 'Cambia lingua',
      dateFormat: 'gg/mm/aaaa',
      resend: 'Reinvia',
    },
    home: {
      users: 'Utenti',
      departments: 'Reparti',
      substances: 'Sostanze',
      departmentSubstances: 'Associazioni Sostanza a Reparto',
      departmentSubstancesToBeEval: 'Da Valutare',
      departmentSubstancesEvaluated: 'Valutate',
    },
    cruds: {
      warningText: 'Attenzione!',
      list: {
        errors: {
          GENERAL: 'Errore durante il recupero dei dati',
          PERSISTENCE: 'Cancellazione non permessa perchè il dato è utilizzato da altri dati',
        },
      },
      view: {
        errors: {
          GENERAL: 'Errore durante il recupero dei dati',
        },
      },
      edit: {
        errors: {
          GENERAL: 'Errore',
          PERSISTENCE: 'Salvataggio non effettuato, ricontrollare dati duplicati',
          evaluation: "Attenzione: se si procede col salvataggio dovranno essere rivalutate delle sostanze. Tali sostanze saranno evidenziate in rosso all'interno della schermata Gestione Sostanze. Procedere?",
        },
      },
    },
    header: {
      registry: {
        label: 'Anagrafiche',
        companies: 'Aziende',
        departments: 'Reparti',
        activities: 'Attività',
        hPhrases: 'Frasi H',
        rPhrases: 'Frasi R',
        agents: 'Agenti',
        machineries: 'Posizione/Impianto',
        acknowlegment: 'Visione SDS'
      },
      departmentActivities: 'Attività a Reparto',
      substances: 'Sostanze Chimiche',
      departmentSubstances: 'Sostanze Reparto',
      substancesManagement: 'Gestione Sostanze',
      departmentsCopy: 'Duplica Reparto',
      searchSDS: 'Ricerca SDS',
      lots: 'Lotti',
      users: 'Utenti',
      logs: 'Log',
      import: 'Import',
      importSubstances: 'Import Sostanze',
      importUsers: 'Import Utenti',
      verisk: 'Integrazione 3E-Verisk',
      verisk_log: 'Log 3E-Verisk',
      verisk_send: 'Invio manuale 3E-Verisk',
      verisk_send_startstop: '3E-Verisk Auto Send Start Stop',
      verisk_send_batch: '3E-Verisk Batch Send',
      acknowlegmentSDS: 'Presa visione SDS',
      acknowlegmentSDSHistory: 'Riepilogo Presa visione'
    },
    activities: {
      title: 'Attività',
      name: 'Nome',
      err: {
        name: 'Nome non può essere vuoto',
      },
    },
    agents: {
      title: 'Agenti',
      description: 'Descrizione',
      casRn: 'CAS RN',
      mixture: 'Miscela',
      err: {
        description: 'Descrizione non può essere vuoto',
        mixture: 'Miscela deve avere un valore'
      },
      warn: {
        cas: 'Il campo CASRN è vuoto',
      },
    },
    companies: {
      title: 'Aziende',
      name: 'Nome',
      err: {
        name: 'Nome non può essere vuoto',
      },
    },
    machineries: {
      title: 'Posizione/Impianto',
      name: 'Nome',
      substances: "Sostanze",
      err: {
        name: 'Nome non può essere vuoto',
      },
    },
    departments: {
      title: 'Reparti',
      name: 'Nome',
      area: 'Area',
      companyId: 'Azienda',
      companyName: 'Azienda',
      manager: 'Responsabile',
      state: {
        name: 'Stato',
        ACTIVE: 'Attivo',
        INACTIVE: 'Disattivo',
      },
      building: 'Edificio',
      labManager: 'Resp. Lab.',
      site: 'Sito',
      dvrIt: 'DVR IT',
      notes: 'Note',
      err: {
        name: 'Nome non può essere vuoto',
        companyId: 'Azienda non può essere vuoto',
        state: 'Stato non può essere vuoto',
      },
    },
    hPhrases: {
      title: 'Frasi H',
      code: 'Codice',
      description: 'Descrizione',
      hazardIndex: 'Ind. Pericolosità',
      cutaneousRisk: {
        name: 'Rischio via cut.',
        true: 'Si',
        false: 'No',
      },
      teratogenRisk: {
        name: 'Rischio teratog.',
        true: 'Si',
        false: 'No',
      },
      inhalationRisk: {
        name: 'Rischio via inal.',
        true: 'Si',
        false: 'No',
      },
      cancerousRisk: {
          name: 'Rischio cancer.',
          true: 'Si',
          false: 'No',
        },
      mutagenRisk: {
          name: 'Rischio mutageno',
          true: 'Si',
          false: 'No',
      },
      atexSubstance: {
        name: 'Sost. ATEX',
        true: 'Si',
        false: 'No',
      },
//      cancerousSubstanceInPrint: {
//        name: 'Sost. cancer. in stampa',
//        true: 'Si',
//        false: 'No',
//      },
//      mutagenSubstanceInPrint: {
//        name: 'Sost. mutag. in stampa',
//        true: 'Si',
//        false: 'No',
//      },
      score: 'Score',
      err: {
        code: 'Codice non può essere vuoto',
        hazardIndex: 'Ind. Pericolosità deve essere un valore maggiore o uguale a 1',
        cutaneousRisk: 'Rischio via cut. non può essere vuoto',
        teratogenRisk: 'Rischio teratog. non può essere vuoto',
        inhalationRisk: 'Rischio via inal. non può essere vuoto',
        cancerousRisk: 'Rischio cancer. non può essere vuoto',
        mutagenRisk: 'Rischio mutageno non può essere vuoto',
        atexSubstance: 'Sost. ATEX non può essere vuoto',
        //cancerousSubstanceInPrint: 'Sost. cancer. in stampa non può essere vuoto',
        //mutagenSubstanceInPrint: 'Sost. mutag. in stampa non può essere vuoto',
      },
    },
    rPhrases: {
      title: 'Frasi R',
      code: 'Codice',
      description: 'Descrizione',
      hazardIndex: 'Ind. Pericolosità',
      cutaneousRisk: {
        name: 'Rischio via cut.',
        true: 'Si',
        false: 'No',
      },
      teratogenRisk: {
        name: 'Rischio teratog.',
        true: 'Si',
        false: 'No',
      },
      inhalationRisk: {
        name: 'Rischio via inal.',
        true: 'Si',
        false: 'No',
      },
      cancerousRisk: {
        name: 'Rischio cancer.',
        true: 'Si',
        false: 'No',
      },
      mutagenRisk: {
        name: 'Rischio mutageno',
        true: 'Si',
        false: 'No',
      },
      atexSubstance: {
        name: 'Sost. ATEX',
        true: 'Si',
        false: 'No',
      },
//      cancerousSubstanceInPrint: {
//        name: 'Sost. cancer. in stampa',
//        true: 'Si',
//        false: 'No',
//      },
//      mutagenSubstanceInPrint: {
//        name: 'Sost. mutag. in stampa',
//        true: 'Si',
//        false: 'No',
//      },
      score: 'Score',
      err: {
        code: 'Codice non può essere vuoto',
        hazardIndex: 'Ind. Pericolosità non può essere vuoto',
        cutaneousRisk: 'Rischio via cut. non può essere vuoto',
        teratogenRisk: 'Rischio teratog. non può essere vuoto',
        inhalationRisk: 'Rischio via inal. non può essere vuoto',
        cancerousRisk: 'Rischio cancer. non può essere vuoto',
        mutagenRisk: 'Rischio mutageno non può essere vuoto',
        atexSubstance: 'Sost. ATEX non può essere vuoto',
//        cancerousSubstanceInPrint: 'Sost. cancer. in stampa non può essere vuoto',
//        mutagenSubstanceInPrint: 'Sost. mutag. in stampa non può essere vuoto',
      },
    },
    lots: {
      title: 'Lotti',
      cas: 'CAS',
      department: {
        id: 'Reparto',
        name: 'Reparto',
      },
      name: 'Lotto',
      storageCabinet: 'Armadio di stoccaggio',
      storageTemperature: {
        name: 'Temperatura di storage',
        POSITIVE: '2-8°C',
        ROOM_TEMPERATURE: 'Temperatura stanza',
        MINUS_80: '-80°C',
        MINUS_20: '-20°C',
      },
      expiryDate: 'Scadenza',
      openingDate: 'Data di apertura',
      barcode: 'Codice a barre prodotto',
      mail: 'Mail utente di riferimento',
      status: {
        name: 'Status',
        SPENT: 'Esaurito',
        DISPOSE: 'Smaltito',
        INUSE: 'In uso',
      },
      building: 'Edificio/Stanza',
      msds: 'MSDS',
      checkInDate: 'Data di arrivo',
      err: {
        cas: 'CAS non può essere vuoto',
        departmentId: 'Reparto non può essere vuoto',
        name: 'Lotto non può essere vuoto',
        storageCabinet: 'Armadio di stoccaggio non può essere vuoto',
        storageTemperature: 'Temperatura di storage non può essere vuoto',
        mail: 'Mail utente di riferimento non valida',
        expiryDate: 'Data di scadenza vuota o non valida',
        openingDate: 'Data di apertura vuota o non valida',
        checkInDate: 'Data di arrivo vuota o non valida',
      },
    },
    advancedSearch: {
      title: 'Cerca Associazioni Reparto - Attività - Sostanza Chimica',
      agent: 'Agente',
      physicalState: 'Stato Fisico',
      supplier: 'Fornitore',
      casRn: 'CAS RN',
      code: 'Codice',
      sds: 'SDS',
      true: 'Si',
      false: 'No',
      state: 'Stato',
      enabled: 'Abilitato',
      disabled: 'Disabilitato',
      toBeEvaluated: 'Da Rivalutare',      
      revelationProcessTemperaturePre: 'Temperatura di processo',
      revelationProcessTemperatureValuesPre: {
    	  PROCESS_TEMPERATURE_LESS: 'Temperatura ambiente o minore',
    	  PROCESS_TEMPERATURE_MED: '25 < T < 60',
    	  PROCESS_TEMPERATURE_MAX: 'T > 60',
      },
      revelationHandlingTimeMinutesPre: 'Tempo di manipolazione in minuti',
      revelationHandlingTimeMinutesShortPre: 'Tempo di manip. in minuti',
      revelationFrequencyOfUseDaysPre: 'Frequenza di utilizzo in giorni',
      rPhrases: {
        name: 'Frasi R',
        cutaneousRisk: 'Rischio Cut.',
        cancerousRisk: 'Cancer.',
        mutagenRisk: 'Mutageno',
        inhalationRisk: 'Inal.',
        code: 'Codice',
      },
      hPhrases: {
        name: 'Frasi H',
        cutaneousRisk: 'Rischio Cut.',
        teratogenRisk: 'Teratog.',
        cancerousRisk: 'Cancer.',
        mutagenRisk: 'Mutageno',
        inhalationRisk: 'Inal.',
        code: 'Codice',
      },
      area: 'Area',
      department: 'Reparto',
      activity: 'Ruolo',
      exposition: 'Tempo di Esposizione',
      frequency: 'Frequenza di Contatto',
      dailyQuantity: {
        name: 'Quantità utilizzata giornalmente',
        min: 'Min',
        max: 'Max',
        um: 'UM',
      },
      presentQuantity: {
        name: 'Quantità presente',
        min: 'Min',
        max: 'Max',
        um: 'UM',
      },
    },
    departmentActivities: {
      title: 'Attività a Reparto',
      handleRemove: "Eliminare l'associazione tra il reparto e l'attività {id}?",
      activities: 'Attività',
      export: "Esporta tutte le associazioni a cui è stato associato almeno un'attività ad un reparto",
      print: "Stampa tutte le associazioni a cui è stato associato almeno un'attività ad un reparto",
      emptyResults: 'Nessuna attività associata',
      withActivities: 'Reparti senza attività',
    },
    departmentSubstances: {
      title: 'Sostanze chimiche per ogni associazione Attività-Reparto',
      titleEdit: 'Modifica associazione sostanza chimica - attività - reparto',
      handleRemove: "Eliminare l'associazione tra il reparto e l'attività e la sostanza {id}?",
      activities: 'Attività',
      value: 'Sostanza',
      emptyResults: 'Nessuna sostanza associata',
      withSubstances: 'Associaz. senza sostanza',
      copyError: 'Si è verificato un errore durante la copia',
    },
    evaluations: {
      title: 'Calcola Rischio Associazione Reparto - Attività - Sostanza Chimica',
      print: 'Stampa Associazioni',
      printEvaluations: 'Stampa Valutazioni',
      printEvaluationsAll: 'Stampa Storico Valutazioni',
      export: 'Esporta Associazioni',
      exportEvaluations: 'Esporta Valutazioni',
      archive: 'Storico',
      last: 'Ultima Valutazione',
      evaluation: 'Valutazione',
      department: 'Reparto',
      activity: 'Attività',
      substance: 'Sostanza Chimica',
      
      
      bigP: 'P',
      revelation: 'Rivelazione',
      revelationCollectiveProtectionFactor: 'Fattore di protezione collettiva',
      revelationCollectiveProtectionFactorValues: {
    	  COOKER_HOOD_EFFICIENT: 'Operazioni tutte svolte sotto cappa efficiente (fare riferimento a rischio chimico)',
    	  COOKER_HOOD_ONLY_PARTIALLY: 'Operazioni svolte solo parzialmente sotto cappa efficienti (esclusi i trasferimenti)',
    	  COOKER_HOOD_NOT_EFFICIENT: 'Utilizzo di cappa non efficiente',
      },
      bigT: 'T',
      revelationProcessTemperature: 'Temperatura di processo',
      revelationProcessTemperatureValues: {
    	  PROCESS_TEMPERATURE_LESS: 'Temperatura ambiente o minore',
    	  PROCESS_TEMPERATURE_MED: '25 < T < 60',
    	  PROCESS_TEMPERATURE_MAX: 'T > 60',
      },
      bigS: 'S',
      revelationChemicalPhysicalState: 'Stato chimico-fisico',
      revelationChemicalPhysicalStateValues: {
    	  STATE_SOLID: 'Gel/Solido compatto',
    	  STATE_CRYSTAL: 'Cristalli/Inclusione in matrice',
    	  STATE_LIQUID: 'Liquido',
    	  STATE_GAS: 'Gas/Vapore/Polvere fine',
      },
      bigQ: 'Q',
      revelationAmountUsed: 'Quantità utilizzata',
      revelationAmountUsedValues: {
    	  AMOUNT_USED_LESS: '< 1 g o < 1 ml',
    	  AMOUNT_USED_MED: '1 g - 50 g o 1 ml - 50 ml',
    	  AMOUNT_USED_MAX: '> 50 g o > 50 ml',
      },   
      bigE: 'E (Tempo di manipolazione in minuti / 480)', 
      bigEShort: 'E (Tempo di manip. in min. / 480)',   
      revelationHandlingTimeMinutes: 'Tempo di manipolazione in minuti',
      revelationHandlingTimeMinutesShort: 'Tempo di manip. in minuti',
      bigF: 'F (Frequenza di utilizzo in giorni / 200)',   
      bigFShort: 'F',   
      revelationFrequencyOfUseDays: 'Frequenza di utilizzo in giorni',
      lcanc: {
          name: 'Lcanc',
          description: 'Lcanc descrizione',
          LcancLabel: 'Lcanc ([P*T*S*E*Q*F] / 6.25)',
        },
        lcancType: {
          NECESSARY: 'Necessità di misure di tutela integrative',
          EFFECTIVE: 'Misure di tutela efficaci',
        },

      
      
      
      
      
      inhalation: 'Inalazione',
      inhalationDistance: 'Distanza',
      inhalationDistanceValues: {
        L_1: '< 1 metro',
        B_1_3: '1 - 3 metri',
        B_3_5: '3 - 5 metri',
        B_5_10: '5 - 10 metri',
        G_10: '> 10 metri',
      },
      smallD: 'd',
      inhalationQuantity: 'Quantità',
      inhalationQuantityValues: {
        L_01: '< 0,1 Kg',
        B_01_1: '0,1 - 1 Kg',
        B_1_10: '1 - 10 Kg',
        B_10_100: '10 - 100 Kg',
        G_100: '> 100 Kg',
      },
      inhalationProperty: 'Proprietà',
      inhalationPropertyValues: {
        SOLID: 'Solido / Nebbia',
        LOW_VOLATILITY: 'Bassa Volatilità',
        MED_VOLATILITY: 'Media / Alta Volatilità',
        GAS: 'Stato Gassoso',
      },
      bigD: 'D (Quantità x Proprietà)',
      inhalationSystemType: 'Sistema',
      inhalationSystemTypeValues: {
        CLOSED_SYSTEM: 'Sistema chiuso',
        MATRIX_INCLUSION: 'Inclusione in matrice',
        CONTROLLED_USE: 'Uso controllato',
        DISPERSIVE_USE: 'Uso dispersivo',
      },
      u: 'U (Sistema x D)',
      inhalationControlType: 'Controllo',
      inhalationControlTypeValues: {
        COMPLETE_CONTAINMENT: 'Contenimento completo',
        LOCALIZED_ASPIRATION: 'Aspirazione localizzata',
        SEGREGATION_SEPARATION: 'Segregazione separazione',
        GENERAL_VENTILATION: 'Ventilazione generale',
        DIRECT_MANIPULATION: 'Manipolazione diretta',
      },
      c: 'C (Controllo x U)',
      inhalationExposureTime: 'Tempo',
      i: 'I (Tempo x C)',
      scoreP: 'P',
      scoreH: 'H',
      skin: 'Cute',
      skinSystemType: 'Sistema',
      skinSystemTypeValues: {
        CLOSED_SYSTEM: 'Sistema chiuso',
        MATRIX_INCLUSION: 'Inclusione in matrice',
        CONTROLLED_USE: 'Uso controllato',
        DISPERSIVE_USE: 'Uso dispersivo',
      },
      skinContactLevel: 'Contatto',
      skinContactLevelValues: {
        NONE: 'Nessun contatto',
        ACCIDENTAL: 'Contatto accidentale',
        DISCONTINUOUS: 'Contatto discontinuo',
        EXTENDED: 'Contatto esteso',
      },
      einal: 'EInal (I x d)',
      rinal: 'RInal (P x EInal)',
      rinalH: 'RInalH (H x EInal)',
      ecute: 'ECute (Sistema x Contatto)',
      rcute: 'RCute (P x Ecute)',
      rcuteH: 'RCuteH (H x Ecute)',
      rcum: {
        name: 'Rcum',
        rcumLabel: 'RCUM (SQRT[(RInal*RINal)+(RCute*RCute)])',
      },
      cumulativeRiskType: {
        NULL: 'Rischio Nullo',
        DANGEROUS: 'Zona di grave rischio',
        HIGH: 'Zona di rischio elevato',
        IRRELEVANT: 'Rischio Irrilevante per la salute',
        RELEVANT: "Rischio superiore all'irrilevante per la salute",
        UNCERTAINTY: 'Intervallo di incertezza',
      },
      rcumH: {
        name: 'RcumH',
        description: 'RcumH descrizione',
        rcumHLabel: 'RCUMH (SQRT[(RInalH*RINalH)+(RCuteH*RCuteH)])',
      },
      dpiUsage: 'Uso DPI in accordo con MSDS',
      usingDpc: 'DPC in uso',
      goToRiskCalculation: 'Vai a Calcolo Rischio',
      viewArchive: 'Visualizza Archivio',
      err: {
        inhalationDistance: 'Distanza non può essere vuoto',
        inhalationQuantity: 'Quantità non può essere vuoto',
        inhalationProperty: 'Proprietà non può essere vuoto',
        inhalationSystemType: 'Sistema inalazione non può essere vuoto',
        inhalationControlType: 'Controllo non può essere vuoto',
        inhalationExposureTime: 'Tempo non può essere vuoto',
        skinSystemType: 'Sistema cute non può essere vuoto',
        skinContactLevel: 'Contatto non può essere vuoto',
        dpiUsage: 'Uso DPI non può essere vuoto',
        usingDpc: 'Uso DPC non può essere vuoto',
        revelationCollectiveProtectionFactor: 'Fattore di protezione non può essere vuoto',
        revelationProcessTemperature: 'Temperatura di processo non può essere vuoto',
        revelationChemicalPhysicalState: 'Stato chimico-fisico non può essere vuoto',
        revelationAmountUsed: 'Quantità utilizzata non può essere vuoto',
        revelationHandlingTimeMinutes: 'Tempo di manipolazione in minuti non può essere vuoto',
        revelationFrequencyOfUseDays: 'Frequenza di utilizzo in giorni non può essere vuoto',
      },
    },
    substances: {
      title: 'Sostanze Chimiche',
      idCode: 'Codice',
      newSds: 'Nuova Scheda Di Sicurezza',
      viewSdsDisabled: 'Inserire una Scheda Di Sicurezza',
      newSdsEvaluation: 'Nuova Valutazione Scheda Di Sicurezza',
      newSdsEvaluationDisabled: 'Impossibile creare una nuova valutazione per una scheda di sicurezza già valutata',
      viewSds: 'Visualizza Scheda Di Sicurezza',
      viewSdsEvaluation: 'Visualizza Valutazione Scheda Di Sicurezza',
      addSds: 'Aggiungi Scheda Di Sicurezza',
      sdsDeletionReason: 'Motivazione',
      addSdsEvaluation: 'Aggiungi Valutazione Scheda Di Sicurezza',
      sdsLong: 'Scheda Di Sicurezza',
      sdsEvaluationLong: 'Valutazione Scheda Di Sicurezza',
      sdsEvaluationCompliantSdsShort: 'SDS Conforme',
      sdsEvaluationCompliantSdsLong: 'La SDS è conforme?',
      sdsEvaluationConsiderationCLPShort: 'Considerazione CLP',
      sdsEvaluationConsiderationCLPLong: 'Ai sensi del CLP, il prodotto è considerato: ',
      sdsEvaluationConsiderationCLPValues: {
    	  DANGEROUS: 'Pericoloso',
    	  NOT_DANGEROUS: 'Non Pericoloso',
      },
      sdsEvaluationItalianSdsShort: 'SDS in lingua italiana',
      sdsEvaluationItalianSdsLong: 'Versione della SDS in lingua italiana: ',
      sdsEvaluationPageNumerationShort: 'Numerazione ed indicazione complessiva',
      sdsEvaluationPageNumerationLong: 'Numerazione delle pagine e indicazione della lunghezza complessiva della SDS: ',
      sdsEvaluationSectionsCompletedShort: 'Presenza e compilazione 16 sezioni',
      sdsEvaluationSectionsCompletedLong: 'Presenza e compilazione delle 16 sezioni e relative sottosezioni: ',
      sdsEvaluationSectionsWithoutTextShort: 'Sottosezioni prive di testo',
      sdsEvaluationSectionsWithoutTextLong: 'La SDS non deve contenere sottosezioni prive di testo: ',
      sdsEvaluationSection1Short: 'Sezione 1',
      sdsEvaluationSection1Long: 'Sezione 1: Identificazione della sostanza o della miscela e della società/impresa. Indicazione di: 1.2. Usi pertinenti identificati e usi sconsigliati, 1.4. Numero telefonico di emergenza: ',
      sdsEvaluationSection2Short: 'Sezione 2',
      sdsEvaluationSection2Long: 'Sezione 2: Identificazione dei pericoli. Deve essere presente la classificazione di pericolosità ai sensi del CLP [Regolamento (CE) n.1272/2008], NON devono essere presenti i riferimenti alla direttiva 67/548/CEE o alla direttiva 1999/45/CE perchè abrogate (no frasi R), NON deve essere presente la “Classificazione ai sensi del GHS”, ma al CLP: ',
      sdsEvaluationUsableSdsShort: 'SDS Utilizzabile',
      sdsEvaluationUsableSdsLong: 'La SDS è utilizzabile?',
      sdsEvaluationNoteShort: 'Note',
      sdsEvaluationNoteLong: 'Note: ',
      supplier: {
        code: 'Cod. Fornitore',
        name: 'Fornitore',
      },
      export: 'Esporta sostanze/frasi/SDS',
      agent: 'Agente',
      physicalState: 'Stato Fisico',
      sds: 'SDS',
      safetyDataSheetVersion: 'Versione',
      true: 'Si',
      false: 'No',
      rPhrases: 'Frasi R',
      hPhrases: 'Frasi H',
      pScore: 'Score P',
      hScore: 'Score H',
      cutaneousRisk: 'Rischio Cut.',
      teratogenRisk: 'Rischio teratog.',
      inhalationRisk: 'Rischio inal.',
      cancerousRisk: 'Sostanza cancer.',
      mutagenRisk: 'Sostanza mutag.',
      atexSubstance: 'ATEX',
      adr: 'ADR',
      cancerousSubstance: 'Cancer.',
      mutagenSubstance: 'Mutag.',
      attachments: 'Allegati',
      solid: 'solido',
      liquid: 'liquido',
      gas: 'gas',
      err: {
        supplierCode: 'Cod. Fornitore non può essere vuoto',
        agent: 'Agente non può essere vuoto',
        physicalState: 'Stato Fisico non può essere vuoto',
        supplier: 'Fornitore non può essere vuoto',
        sds: 'SDS non può essere vuoto',
        attachments: 'Allegati non può essere vuoto',
        sdsEvaluationClp: 'Ai sensi del CLP, il prodotto è considerato non può essere vuoto',
        sdsEvaluationItalianSds: 'Versione della SDS in lingua italiana non può essere vuoto',
        sdsEvaluationPageNumeration: 'Numerazione ed indicazione complessiva non può essere vuoto',
        sdsEvaluationSectionsCompleted: 'Presenza e compilazione delle 16 sezioni e relative sottosezioni non può essere vuoto',
        sdsEvaluationSectionsWithoutText: 'La SDS non deve contenere sottosezioni prive di testo non può essere vuoto',
        sdsEvaluationSection1: 'Sezione 1: Identificazione della sostanza o della miscela e della società/impresa non può essere vuoto',
        sdsEvaluationSection2: 'Sezione 2: Identificazione dei pericoli non può essere vuoto',
        sdsEvaluationCompliantSds: 'La SDS è conforme? non può essere vuoto',
        sdsEvaluationUsableSds: 'La SDS è utilizzabile? non può essere vuoto',
      },
    },
    substancesManagement: {
      title: 'Associazione Reparto - Attività - Sostanza Chimica',
      view: 'Visualizza Valutazione',
      new: 'Nuova Valutazione',
      notAllowed: 'Compila i dati mancanti per poter effettuare una nuova valutazione',
      disabled: 'Impossibile creare una nuova valutazione per una sostanza non attiva',
      archive: 'Visualizza Archivio',
      unit: 'Unità di misura',
      print: 'Stampa Valutazione',
      

      revelationProcessTemperaturePre: 'Temperatura di processo',
      revelationProcessTemperatureValuesPre: {
    	  PROCESS_TEMPERATURE_LESS: 'Temperatura ambiente o minore',
    	  PROCESS_TEMPERATURE_MED: '25 < T < 60',
    	  PROCESS_TEMPERATURE_MAX: 'T > 60',
      },
      revelationHandlingTimeMinutesPre: 'Tempo di manipolazione in minuti',
      revelationHandlingTimeMinutesShortPre: 'Tempo di manip. in minuti',
      revelationFrequencyOfUseDaysPre: 'Frequenza di utilizzo in giorni',
      
      
      
      weightUnitValues: {
        MG: 'mg',
        G: 'g',
        KG: 'kg',
      },
      contactFrequencyValues: {
        DAILY: 'Giornaliera',
        WEEKLY: 'Settimanale',
        MONTHLY: 'Mensile',
        HALF_YEARLY: 'Semestrale',
        YEARLY: 'Annuale',
      },
      expositionTimeValues: {
        L_15: '< 15 minuti',
        B_15_2: '15 minuti – 2 ore',
        B_2_4: '2 ore – 4 ore',
        B_4_6: '4 ore – 6 ore',
        G_6: '> 6 ore',
      },
      quantity: 'Quantità',
      dailyQuantity: {
        comparator: 'Quantità utilizzata giornalmente',
        displayLabel: 'Qta. giornaliera',
      },
      dailyUsage: {
        displayLabel: 'Consumo giornaliero',
      },
      stock: {
        displayLabel: 'Giacienza',
      },
      presentQuantity: {
        comparator: 'Quantità presente',
        displayLabel: 'Qta. presente',
      },
      handlingTemperature: {
        name: 'Temperatura di manipolazione (in °C)',
        displayLabel: 'Temp. di manipolaz. (°C)',
      },
      frequency: {
        name: 'Frequenza di contatto',
        displayLabel: 'Freq. di contatto',
      },
      expositionTime: {
        name: 'Tempo di esposizione',
        displayLabel: 'Tempo di esposizione',
      },
      actions: 'Azioni',
      department: 'Reparto',
      activity: 'Attività',
      substance: 'Sostanza Chimica',
      dpiUse: 'Uso DPI in accordo con MSDS',
      dpcUse: 'DPC in uso',
      risk: {
        irrelevant: 'Rischio irrilevante per la salute',
      },
      err: {
        handlingTemperature: 'Temperature di manipolazione non può essere vuota',
        contactFrequency: 'Frequenza di contatto non può essere vuoto',
        exposureTime: 'Tempo di esposizione non può essere vuoto',
      },
    },
    departmentsCopy: {
      title: 'Duplica Reparto',
      name: 'Nome',
      area: 'Area',
      companyId: 'Azienda',
      companyName: 'Azienda',
      manager: 'Responsabile',
      state: {
        name: 'Stato',
        ACTIVE: 'Attivo',
        INACTIVE: 'Disattivo',
      },
      building: 'Edificio',
      labManager: 'Resp. Lab.',
      site: 'Sito',
      dvrIt: 'DVR IT',
      notes: 'Note',
      associationsMessage: 'Le seguenti associazioni verranno copiate automaticamente con la duplicazione',
    },
    users: {
      title: 'Utenti',
      firstName: 'Nome',
      lastName: 'Cognome',
      fullName: 'Nome',
      username: 'Username',
      password: 'Password',
      email: 'E-Mail',
      role: 'Ruolo',
      roles: 'Ruoli',
      department: 'Reparto',
      machineries: 'Posizione/Impianto',
      roleNames: {
        A: 'Administrator',
        B: 'Chem Manager',
        C: 'Chem Update',
        D: 'Chem View',
        E: 'Batch Manager',
        F: 'SDS View',
        G: 'SDS Annual check'
      },
      reset: 'Reset Password',
      err: {
        firstName: 'Nome non valido',
        lastName: 'Cognome non valido',
        username: 'Username non valido',
        email: 'E-Mail non valida',
        roles: 'Inserire almeno un ruolo',
        department: 'Reparto non valido',
      },
    },
    logs: {
      title: 'Log',
      username: 'Utente',
      timestamp: 'Orario',
      description: 'Descrizione',
      from: 'Da (gg/mm/aaaa)',
      to: 'A (gg/mm/aaaa)',
    },
    verisk: {
      logtitle: 'Log 3E-Verisk',
      sendtitle: 'Invio Manuale 3E-Verisk',
      timestamp: 'Orario',
      description: 'Descrizione',
      from: 'Da (gg/mm/aaaa)',
      to: 'A (gg/mm/aaaa)',
      sdsuuid: 'SDS ID',
      sdsdocumentuuid: 'ID Documento SDS',
      sdsdocumentname: 'Nome Documento SDS',
      productuuid: 'ID Prodotto',
      product: 'Sostanza',
      useruuid: 'ID Utente',
      user: 'Utente',
      senderror: 'Messaggio di errore',
      sendnow: 'Invia adesso',
      sendremove: 'Elimina',
    },
    login: {
      username: 'Username',
      password: 'Password',
      error: 'Username o Password errato/i',
      submit: 'Effettua il Login',
      passwordChanged: 'Password cambiata con successo',
      missingUsernameOrPassword: 'Username e/o Password mancanti',
    },
    changePassword: {
      new: 'Nuova Password',
      newRepeat: 'Inserisci di nuovo la Password',
      old: 'Vecchia Password',
      submit: 'Cambia Password',
      message: "E' necessario aggiornare la tua password",
      message2: 'La nuova password non può essere uguale al tuo username o alla password precedente',
      notMatching: 'Le password inserite non corrispondono',
      length: 'La nuova password deve essere almeno 8 caratteri',
      serverError: 'Errore durante il cambio password. Ricontrolla la tua vecchia password e i requisiti per la nuova',
    },
    import: {
      submit: 'Importa i file selezionati',
      results: "Esito dell'import",
    },
    acknowlegmentSDS: {
      acknowledged: 'Presa visione',
      acknowledger: 'Visionatore',
      acknowledgedTimestamp: 'Timestamp',
      addTitle: 'Registra presa visione',
      handleAdd: 'Vuoi registrare la presa visione per la SDS?',
      machineries: "Posizione/Impianto",
    },
    searchSDS: {
      searchField: 'Ricerca una sostanza inserendo CAS o parte del codice sostanza',
      machineries: "Posizione/Impianto",
    },
  },
  en: {
    general: {
      fullSearch: 'Filter Results',
      quickSearch: 'Quick Search',
      advancedSearch: 'Advanced Search',
      department: 'Department',
      activity: 'Activity',
      substance: 'Substance',
      close: 'Close',
      add: 'Add',
      modify: 'Modify',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      view: 'View',
      confirm: 'Confirm',
      print: 'Print',
      export: 'Export',
      clear: 'Clear',
      enable: 'Enable',
      disable: 'Disable',
      search: 'Search',
      download: 'Download attachment',
      duplicate: 'Duplicate',
      results: 'Results',
      clearFilters: 'Clear Filters',
      sessionExpired: 'Session is expired. Log in to the system again',
      goToLogin: 'Go to Login Page',
      confirmDeletion: {
        title: 'Confirm action?',
        text: 'Confirm deletion of this element?',
      },
      acknowlegmentSDShandleAdd: {
        title: 'Record acknowledgment',
        text: 'Do you want to record the acknowledgment of the SDS?',
      },
      signature: {
        title: '',
        text: 'Input your password to confirm the action',
        input: 'Password',
      },
      dropzone: {
        content: 'Drop file(s) here to upload',
        button: 'Choose file(s) to upload',
        error: 'An error has occurred while uploading',
        rejected: 'File was not uploaded because size exceeds the limits (10MB)',
      },
      noResults: 'No results found',
      valueChoosing: 'Choose value',
      noAssociations: 'No added association',
      errorOccurred: 'An error occurred',
      deleteAssociation: 'Delete association between',
      and: 'and',
      andOther: 'and other',
      of: 'of',
      toggleLocale: 'Toggle language',
      dateFormat: 'dd/mm/yyyy',
      resend: 'Resend',
    },
    home: {
      users: 'Users',
      departments: 'Departments',
      substances: 'Substances',
      departmentSubstances: 'Department-Substances Associations',
      departmentSubstancesToBeEval: 'To Be Evaluated',
      departmentSubstancesEvaluated: 'Evaluated',
    },
    cruds: {
      warningText: 'Warning!',
      list: {
        errors: {
          GENERAL: 'Error in data retrieval',
          PERSISTENCE: 'Delete not allowed, the entity is referenced by other entities',
        },
      },
      view: {
        errors: {
          GENERAL: 'Error in data retrieval',
        },
      },
      edit: {
        errors: {
          GENERAL: 'Error',
          PERSISTENCE: 'Save unsuccessful, check data duplication',
          evaluation: 'Warning: submitting this action will cause the need for new evaluations. You will find these substances marked in red in the Substances Management section. Proceed?',
        },
      },
    },
    header: {
      registry: {
        label: 'Registry',
        companies: 'Companies',
        departments: 'Departments',
        activities: 'Activities',
        hPhrases: 'H Phrases',
        rPhrases: 'R Phrases',
        agents: 'Agents',
        machineries: 'Position/Facility',
        acknowlegment: 'Acknowlegment SDS'
      },
      departmentActivities: 'Department Activities',
      substances: 'Chemical Substances',
      departmentSubstances: 'Department Substances',
      substancesManagement: 'Substances Management',
      departmentsCopy: 'Departments Copy',
      searchSDS: 'Search SDS',
      lots: 'Batches',
      users: 'Users',
      logs: 'Logs',
      import: 'Import',
      importSubstances: 'Import Sostanze',
      importUsers: 'Import Utenti',
      verisk: '3E-Verisk Integration',
      verisk_log: '3E-Verisk Log',
      verisk_send: '3E-Verisk Manual Send',
      verisk_send_startstop: '3E-Verisk Auto Send Start Stop',
      verisk_send_batch: '3E-Verisk Batch Send',
      acknowlegmentSDS: 'Acknowlegment SDS',
      acknowlegmentSDSHistory: 'History Acknowlegment SDS'
    },
    activities: {
      title: 'Activities',
      name: 'Name',
      err: {
        name: 'Name cannot be empty',
      },
    },
    agents: {
      title: 'Agents',
      description: 'Description',
      casRn: 'CAS RN',
      mixture: 'Mixture',
      err: {
        description: 'Description cannot be empty',
        mixture: 'Mixture flag cannot be null'
      },
      warn: {
        cas: 'CAS RN field is empty',
      },
    },
    companies: {
      title: 'Companies',
      name: 'Name',
      err: {
        name: 'Name cannot be empty',
      },
    },
    machineries: {
      title: 'Machineries',
      name: 'Name',
      substances: "Substances",
      err: {
        name: 'Name cannot be empty',
      },
    },
    departments: {
      title: 'Departments',
      name: 'Name',
      area: 'Area',
      companyId: 'Company',
      companyName: 'Company',
      manager: 'Manager',
      state: {
        name: 'State',
        ACTIVE: 'Active',
        INACTIVE: 'Not Active',
      },
      building: 'Building',
      labManager: 'Lab. Manager',
      site: 'Site',
      dvrIt: 'DVR IT',
      notes: 'Notes',
      err: {
        name: 'Name cannot be empty',
        companyId: 'Company cannot be empty',
        state: 'State cannot be empty',
      },
    },
    hPhrases: {
      title: 'H Phrases',
      code: 'Code',
      description: 'Description',
      hazardIndex: 'Hazard Ind.',
      cutaneousRisk: {
        name: 'Cutaneous Risk',
        true: 'Yes',
        false: 'No',
      },
      teratogenRisk: {
        name: 'Teratogen Risk',
        true: 'Yes',
        false: 'No',
      },
      inhalationRisk: {
        name: 'Inhalation Risk',
        true: 'Yes',
        false: 'No',
      },
      cancerousRisk: {
          name: 'Cancerous Risk',
          true: 'Yes',
          false: 'No',
        },
      mutagenRisk: {
          name: 'Mutagen Risk',
          true: 'Yes',
          false: 'No',
        },
      atexSubstance: {
        name: 'ATEX Substance',
        true: 'Yes',
        false: 'No',
      },
//      cancerousSubstanceInPrint: {
//        name: 'Cancer. substance in print',
//        true: 'Yes',
//        false: 'No',
//      },
//      mutagenSubstanceInPrint: {
//        name: 'Mutag. substance in print',
//        true: 'Yes',
//        false: 'No',
//      },
      score: 'Score',
      err: {
        code: 'Code cannot be empty',
        hazardIndex: 'Hazard Ind. must be a value greater or equal to 1',
        cutaneousRisk: 'Cutaneous Risk cannot be empty',
        teratogenRisk: 'Teratogen Risk cannot be empty',
        inhalationRisk: 'Inhalation Risk cannot be empty',
        cancerousRisk: 'Cancerous Risk cannot be empty',
        mutagenRisk: 'Mutagen Risk cannot be empty',
        atexSubstance: 'ATEX Substance cannot be empty',
//        cancerousSubstanceInPrint: 'Cancer. substance in print cannot be empty',
//        mutagenSubstanceInPrint: 'Mutag. substance in print cannot be empty',
      },
    },
    rPhrases: {
      title: 'R Phrases',
      code: 'Code',
      description: 'Description',
      hazardIndex: 'Hazard Ind.',
      cutaneousRisk: {
        name: 'Cutaneous Risk',
        true: 'Yes',
        false: 'No',
      },
      inhalationRisk: {
        name: 'Inhalation Risk',
        true: 'Yes',
        false: 'No',
      },
      cancerousRisk: {
          name: 'Cancerous Risk',
          true: 'Yes',
          false: 'No',
        },
      mutagenRisk: {
          name: 'Mutagen Risk',
          true: 'Yes',
          false: 'No',
        },
      atexSubstance: {
        name: 'ATEX Substance',
        true: 'Yes',
        false: 'No',
      },
//      cancerousSubstanceInPrint: {
//        name: 'Cancer. substance in print',
//        true: 'Yes',
//        false: 'No',
//      },
//      mutagenSubstanceInPrint: {
//        name: 'Mutag. substance in print',
//        true: 'Yes',
//        false: 'No',
//      },
      score: 'Score',
      err: {
        code: 'Code cannot be empty',
        hazardIndex: 'Hazard Ind. cannot be empty',
        cutaneousRisk: 'Cutaneous Risk cannot be empty',
        inhalationRisk: 'Inhalation Risk cannot be empty',
        cancerousRisk: 'Cancerous Risk cannot be empty',
        mutagenRisk: 'Mutagen Risk cannot be empty',
        teratogenRisk: 'Teratogen Risk cannot be empty',
        atexSubstance: 'ATEX Substance cannot be empty',
//        cancerousSubstanceInPrint: 'Cancer. substance in print cannot be empty',
//        mutagenSubstanceInPrint: 'Mutag. substance in print cannot be empty',
      },
    },
    lots: {
      title: 'Batches',
      cas: 'CAS',
      department: {
        id: 'Department',
        name: 'Department',
      },
      name: 'Batch',
      storageCabinet: 'Storage Cabinet',
      storageTemperature: {
        name: 'Storage Temperature',
        POSITIVE: '2-8°C',
        ROOM_TEMPERATURE: 'Room Temperature',
        MINUS_80: '-80°C',
        MINUS_20: '-20°C',
      },
      expiryDate: 'Expiry Date',
      openingDate: 'Opening Date',
      barcode: 'Product Barcode',
      mail: 'Reference user mail',
      status: {
        name: 'Status',
        SPENT: 'Out of Stock',
        DISPOSE: 'Disposed',
        INUSE: 'In use',
      },
      building: 'Building/Room',
      msds: 'MSDS',
      checkInDate: 'Check-in Date',
      err: {
        cas: 'CAS cannot be empty',
        departmentId: 'Department cannot be empty',
        name: 'Batch cannot be empty',
        storageCabinet: 'Storage Cabinet cannot be empty',
        storageTemperature: 'Storage Temperature cannot be empty',
        mail: 'Invalid Reference user mail',
        expiryDate: 'Expiry Date empty or not valid format',
        openingDate: 'Opening Date empty or not valid format',
        checkInDate: 'Check-in Date empty or not valid format',
      },
    },
    advancedSearch: {
      title: 'Search Associations Department - Activity - Chemical Substance',
      agent: 'Agent',
      physicalState: 'Physical State',
      supplier: 'Supplier',
      casRn: 'CAS RN',
      code: 'Code',
      sds: 'SDS',
      true: 'Yes',
      false: 'No',
      state: 'Status',
      enabled: 'Enabled',
      disabled: 'Disabled',
      toBeEvaluated: 'To Be Evaluated',
      revelationProcessTemperaturePre: 'Process temperature',
      revelationProcessTemperatureValuesPre: {
    	  PROCESS_TEMPERATURE_LESS: 'Ambient or lower temperature',
    	  PROCESS_TEMPERATURE_MED: '25 < T < 60',
    	  PROCESS_TEMPERATURE_MAX: 'T > 60',
      },
      revelationHandlingTimeMinutesPre: 'Handling time in minutes',
      revelationHandlingTimeMinutesShortPre: 'Handling time in minutes',
      revelationFrequencyOfUseDaysPre: 'Frequency of use in days',
      rPhrases: {
        name: 'R Phrases',
        cutaneousRisk: 'Cutaneous Risk',
        cancerousRisk: 'Cancerous Risk',
        mutagenRisk: 'Mutagen Risk',
        inhalationRisk: 'Inhalation Risk',
        code: 'Code',
      },
      hPhrases: {
        name: 'H Phrases',
        cutaneousRisk: 'Cutaneous Risk',
        teratogenRisk: 'Teratogen Risk',
        cancerousRisk: 'Cancerous Risk',
        mutagenRisk: 'Mutagen Risk',
        inhalationRisk: 'Inhalation Risk',
        code: 'Code',
      },
      area: 'Area',
      department: 'Department',
      activity: 'Role',
      exposition: 'Exposition time',
      frequency: 'Contact frequency',
      dailyQuantity: {
        name: 'Quantity used daily',
        min: 'Min',
        max: 'Max',
        um: 'UM',
      },
      presentQuantity: {
        name: 'Current quantity',
        min: 'Min',
        max: 'Max',
        um: 'UM',
      },
    },
    departmentActivities: {
      title: 'Department Activities',
      handleRemove: 'Delete association between department and activity {id}?',
      activities: 'Activities',
      export: 'Export all the associations where a department has been associated with at least one activity',
      print: 'Print all the associations where a department has been associated with at least one activity',
      emptyResults: 'No activity association',
      withActivities: 'Departments w/o activities',
    },
    departmentSubstances: {
      title: 'Chemical substances for every association Activity-Department',
      titleEdit: 'Edit Chemical substances - Activity - Department association',
      handleRemove: 'Delete association between department, activity and substance {id}?',
      activities: 'Activities',
      value: 'Substance',
      emptyResults: 'No substance association',
      withSubstances: 'Association w/o subst.',
      copyError: 'An error occurred during the copy operation',
    },
    evaluations: {
      title: 'Association Department - Activity - Chemical Substance',
      archive: 'Evaluations for',
      print: 'Print associations list',
      printEvaluations: 'Print evaluations list',
      printEvaluationsAll: 'Print all evaluations',
      export: 'Export associations list',
      exportEvaluations: 'Export evaluations list',
      last: 'Last Evaluation',
      evaluation: 'Evaluation',
      department: 'Department',
      activity: 'Activity',
      substance: 'Chemical Substance',
      
      
      
      bigP: 'P',
      revelation: 'Revelation',
      revelationCollectiveProtectionFactor: 'Collective protection factor',
      revelationCollectiveProtectionFactorValues: {
    	  COOKER_HOOD_EFFICIENT: 'Operations all carried out under an efficient hood (refer to chemical risk)',
    	  COOKER_HOOD_ONLY_PARTIALLY: 'Operations performed only partially under efficient hood (excluding transfers)',
    	  COOKER_HOOD_NOT_EFFICIENT: 'Use of inefficient hood',
      },
      bigT: 'T',
      revelationProcessTemperature: 'Process temperature',
      revelationProcessTemperatureValues: {
    	  PROCESS_TEMPERATURE_LESS: 'Ambient or lower temperature',
    	  PROCESS_TEMPERATURE_MED: '25 < T < 60',
    	  PROCESS_TEMPERATURE_MAX: 'T > 60',
      },
      bigS: 'S',
      revelationChemicalPhysicalState: 'Chemical-physical state',
      revelationChemicalPhysicalStateValues: {
    	  STATE_SOLID: 'Gel / Compact solid',
    	  STATE_CRYSTAL: 'Crystals / Matrix inclusion',
    	  STATE_LIQUID: 'Liquid',
    	  STATE_GAS: 'Gas / Steam / Fine powder',
      },
      bigQ: 'Q',
      revelationAmountUsed: 'Amount used',
      revelationAmountUsedValues: {
    	  AMOUNT_USED_LESS: '< 1 g o < 1 ml',
    	  AMOUNT_USED_MED: '1 g - 50 g o 1 ml - 50 ml',
    	  AMOUNT_USED_MAX: '> 50 g o > 50 ml',
      },
      bigE: 'E (Handling time in minutes / 480)' ,   
      bigEShort: 'E',   
      revelationHandlingTimeMinutes: 'Handling time in minutes',
      revelationHandlingTimeMinutesShort: 'Handling time in minutes',
      bigF: 'F (Frequency of use in days / 200)',    
      bigFShort: 'F',   
      revelationFrequencyOfUseDays: 'Frequency of use in days',
      lcanc: {
          name: 'Lcanc',
          description: 'Lcanc description',
          LcancLabel: 'Lcanc ([P*T*S*E*Q*F] / 6.25)',
        },
      lcancType: {
          NECESSARY: 'Need for additional protective measures',
          EFFECTIVE: 'Effective protective measures',
        },

      
      
      
      
      
      
      
      inhalationDistance: 'Distance',
      inhalationDistanceValues: {
        L_1: '< 1 meter',
        B_1_3: '1 - 3 meter',
        B_3_5: '3 - 5 meter',
        B_5_10: '5 - 10 meter',
        G_10: '> 10 meter',
      },
      smallD: 'd',
      inhalationQuantity: 'Quantity',
      inhalationQuantityValues: {
        L_01: '< 0,1 Kg',
        B_01_1: '0,1 - 1 Kg',
        B_1_10: '1 - 10 Kg',
        B_10_100: '10 - 100 Kg',
        G_100: '> 100 Kg',
      },
      inhalationProperty: 'Property',
      inhalationPropertyValues: {
        SOLID: 'Solid / Haze',
        LOW_VOLATILITY: 'Low Volatility',
        MED_VOLATILITY: 'Medium / High Volatility',
        GAS: 'Gas Status',
      },
      bigD: 'D (Quantiy x Property)',
      inhalationSystemType: 'System',
      inhalationSystemTypeValues: {
        CLOSED_SYSTEM: 'Closed System',
        MATRIX_INCLUSION: 'Matrix Inclusion',
        CONTROLLED_USE: 'Controlled Use',
        DISPERSIVE_USE: 'Dispersive Use',
      },
      u: 'U (Sistema x D)',
      inhalationControlType: 'Controllo',
      inhalationControlTypeValues: {
        COMPLETE_CONTAINMENT: 'Complete Containment',
        LOCALIZED_ASPIRATION: 'Localized Aspiration',
        SEGREGATION_SEPARATION: 'Segregation Separation',
        GENERAL_VENTILATION: 'General Ventilation',
        DIRECT_MANIPULATION: 'Direct Manipulation',
      },
      c: 'C (Control x U)',
      inhalationExposureTime: 'Time',
      i: 'I (Time x C)',
      scoreP: 'P',
      scoreH: 'H',
      einal: 'EInal (I x d)',
      rinal: 'RInal (P x EInal)',
      rinalH: 'RInalH (H x EInal)',
      skin: 'Skin',
      skinSystemType: 'System',
      skinSystemTypeValues: {
        CLOSED_SYSTEM: 'Closed System',
        MATRIX_INCLUSION: 'Matrix Inclusion',
        CONTROLLED_USE: 'Controlled Use',
        DISPERSIVE_USE: 'Dispersive Use',
      },
      skinContactLevel: 'Contact',
      skinContactLevelValues: {
        NONE: 'None',
        ACCIDENTAL: 'Accidental contact',
        DISCONTINUOUS: 'Discontinuos contact',
        EXTENDED: 'Extended contact',
      },
      ecute: 'ECute (System x Contact)',
      rcute: 'RCute (P x Ecute)',
      rcuteH: 'RCuteH (H x Ecute)',
      rcum: {
        name: 'Rcum',
        rcumLabel: 'RCUM (SQRT[(RInal*RINal)+(RCute*RCute)])',
      },
      rcumH: {
        name: 'RcumH',
        description: 'RcumH description',
        rcumHLabel: 'RCUMH (SQRT[(RInalH*RINalH)+(RCuteH*RCuteH)])',
      },
      cumulativeRiskType: {
        NULL: 'Zero risk',
        DANGEROUS: 'Grave risk zone',
        HIGH: 'High risk zone',
        IRRELEVANT: 'Irrelevant risk for health',
        RELEVANT: 'Relevant risk for health',
        UNCERTAINTY: 'Uncertainty zone',
      },
      dpiUsage: 'DPI usage in accordance with MSDS',
      usingDpc: 'Using DPC',
      goToRiskCalculation: 'Go to Risk Calculation',
      viewArchive: 'View Archive',
      err: {
        inhalationDistance: 'Distance cannot be empty',
        inhalationQuantity: 'Quantity cannot be empty',
        inhalationProperty: 'Property cannot be empty',
        inhalationSystemType: 'Inhal. System cannot be empty',
        inhalationControlType: 'Control cannot be empty',
        inhalationExposureTime: 'Time cannot be empty',
        skinSystemType: 'Skin System cannot be empty',
        skinContactLevel: 'Contact cannot be empty',
        dpiUsage: 'DPI usage cannot be empty',
        usingDpc: 'DPC usage cannot be empty',
        revelationCollectiveProtectionFactor: 'Collective protection factor cannot be empty',
        revelationProcessTemperature: 'Process temperature cannot be empty',
        revelationChemicalPhysicalState: 'Chemical-physical state cannot be empty',
        revelationAmountUsed: 'Amount used cannot be empty',
        revelationHandlingTimeMinutes: 'Handling time in minutes cannot be empty',
        revelationFrequencyOfUseDays: 'Frequency of use in days cannot be empty',
      },
    },
    substances: {
      title: 'Chemical Substances',
      newSds: 'New Safety Data Sheet',
      viewSdsDisabled: 'Add Safety Data Sheet',
      newSdsEvaluation: 'New Evaluation Safety Data Sheet',
      newSdsEvaluationDisabled: 'Unable to create a new evaluation for a Safety Data Sheet that has already been evaluated',
      viewSds: 'View Safety Data Sheet',
      viewSdsEvaluation: 'View Evaluation Safety Data Sheet',
      addSds: 'Add Safety Data Sheet',
      sdsDeletionReason: 'Reason',
      addSdsEvaluation: 'Add Evaluation Safety Data Sheet',
      sdsLong: 'Safety Data Sheet',
      sdsEvaluationLong: 'Evaluation Safety Data Sheet',
      sdsEvaluationCompliantSdsShort: 'SDS Conforme',
      sdsEvaluationCompliantSdsLong: 'La SDS è conforme?',
      sdsEvaluationConsiderationCLPShort: 'CLP Consideration',
      sdsEvaluationConsiderationCLPLong: 'Under the CLP, the product is considered: ',
      sdsEvaluationConsiderationCLPValues: {
    	  DANGEROUS: 'Dangerous',
    	  NOT_DANGEROUS: 'Not Dangerous',
      },
      sdsEvaluationItalianSdsShort: 'SDS in italian version',
      sdsEvaluationItalianSdsLong: 'Italian version of the SDS: ',
      sdsEvaluationPageNumerationShort: 'Page numbering and indication of the overall length',
      sdsEvaluationPageNumerationLong: 'Page numbering and indication of the overall length of the SDS: ',
      sdsEvaluationSectionsCompletedShort: 'Presence and compilation of the 16 sections',
      sdsEvaluationSectionsCompletedLong: 'Presence and compilation of the 16 sections and related subsections: ',
      sdsEvaluationSectionsWithoutTextShort: 'Subsections without text',
      sdsEvaluationSectionsWithoutTextLong: 'The SDS must not contain subsections without text: ',
      sdsEvaluationSection1Short: 'Section 1',
      sdsEvaluationSection1Long: 'Section 1: Identification of the substance or mixture and of the company / undertaking. Indication of: 1.2. Relevant identified uses and uses advised against, 1.4. Emergency telephone number: ',
      sdsEvaluationSection2Short: 'Section 2',
      sdsEvaluationSection2Long: 'Section 2: Hazards Identification. The classification of danger according to CLP [Regulation (EC) n.1272 / 2008] must be present, references to directive 67/548 / EEC or directive 1999/45 / EC must NOT be present because they are repealed (no R phrases ), The "Classification under the GHS" must NOT be present, but CLP: ',
      sdsEvaluationUsableSdsShort: 'SDS Usable',
      sdsEvaluationUsableSdsLong: 'Is the SDS usable?',
      sdsEvaluationNoteShort: 'Note',
      sdsEvaluationNoteLong: 'Note: ',
      idCode: 'Code',
      supplier: {
        code: 'Supplier Code',
        name: 'Supplier',
      },
      agent: 'Agent',
      export: 'Export substances/phrases/SDS',
      physicalState: 'Physical State',
      sds: 'SDS',
      safetyDataSheetVersion: 'Version',
      true: 'Yes',
      false: 'No',
      rPhrases: 'R Phrases',
      hPhrases: 'H Phrases',
      pScore: 'P Score',
      hScore: 'H Score',
      cutaneousRisk: 'Cutaneous Risk',
      teratogenRisk: 'Teratogen Risk',
      inhalationRisk: 'Inhalation Risk',
      cancerousRisk: 'Cancerous Substance',
      mutagenRisk: 'Mutagen Substance',
      atexSubstance: 'ATEX',
      adr: 'ADR',
      cancerousSubstance: 'Cancer.',
      mutagenSubstance: 'Mutag.',
      attachments: 'Attachments',
      solid: 'solid',
      liquid: 'liquid',
      gas: 'gas',
      err: {
        supplierCode: 'Supplier Code cannot be empty',
        agent: 'Agent cannot be empty',
        physicalState: 'Physical State cannot be empty',
        supplier: 'Supplier cannot be empty',
        sds: 'SDS cannot be empty',
        attachments: 'Attachments cannot be empty',
        sdsEvaluationClp: 'Under the CLP, the product is considered cannot be empty',
        sdsEvaluationItalianSds: 'Italian version of the SDS cannot be empty',
        sdsEvaluationPageNumeration: 'Page numbering and indication of the overall length cannot be empty',
        sdsEvaluationSectionsCompleted: 'Presence and compilation of the 16 sections cannot be empty',
        sdsEvaluationSectionsWithoutText: 'The SDS must not contain subsections without text cannot be empty',
        sdsEvaluationSection1: 'Section 1: Identification of the substance or mixture and of the company / undertaking cannot be empty',
        sdsEvaluationSection2: 'Section 2: Hazards Identification cannot be empty',
        sdsEvaluationCompliantSds: 'Under the CLP, the product is considered cannot be empty',
        sdsEvaluationUsableSds: 'Is the SDS usable? non può essere vuoto cannot be empty',
      },
    },
    substancesManagement: {
      title: 'Association Department - Activity - Chemical Substance',
      view: 'View Evaluation',
      new: 'New Evaluation',
      notAllowed: 'Fill the missing data to access evaluation page',
      disabled: 'Unable to create a new evaluation for a non-active substance',
      archive: 'View Archive',
      unit: 'Measurement Unit',
      print: 'Print Evaluation',
      

      revelationProcessTemperaturePre: 'Process temperature',
      revelationProcessTemperatureValuesPre: {
    	  PROCESS_TEMPERATURE_LESS: 'Ambient or lower temperature',
    	  PROCESS_TEMPERATURE_MED: '25 < T < 60',
    	  PROCESS_TEMPERATURE_MAX: 'T > 60',
      },
      revelationHandlingTimeMinutesPre: 'Handling time in minutes',
      revelationHandlingTimeMinutesShortPre: 'Handling time in minutes',
      revelationFrequencyOfUseDaysPre: 'Frequency of use in days',
      
      
      
      contactFrequencyValues: {
        DAILY: 'Daily',
        WEEKLY: 'Weekly',
        MONTHLY: 'Monthly',
        HALF_YEARLY: 'Half yearly',
        YEARLY: 'Yearly',
      },
      weightUnitValues: {
        MG: 'mg',
        G: 'g',
        KG: 'kg',
      },
      expositionTimeValues: {
        L_15: '< 15 minutes',
        B_15_2: '15 minutes – 2 hours',
        B_2_4: '2 hours – 4 hours',
        B_4_6: '4 hours – 6 hours',
        G_6: '> 6 hours',
      },
      quantity: 'Quantity',
      dailyQuantity: {
        comparator: 'Quantity used daily',
        displayLabel: 'Daily Quantity',
      },
      dailyUsage: {
        displayLabel: 'Daily Usage',
      },
      stock: {
        displayLabel: 'Stock',
      },
      presentQuantity: {
        comparator: 'Current Quantity',
        displayLabel: 'Current Quantity',
      },
      handlingTemperature: {
        name: 'Handling temperature (in °C)',
        displayLabel: 'Handling temp. (°C)',
      },
      frequency: {
        name: 'Contact Frequency',
        displayLabel: 'Contact Frequency',
      },
      expositionTime: {
        name: 'Exposition Time',
        displayLabel: 'Exposition Time',
      },
      actions: 'Actions',
      department: 'Department',
      activity: 'Activity',
      substance: 'Chemical Substance',
      dpiUse: 'Use DPI in accordance with MSDS',
      dpcUse: 'DPC in use',
      risk: {
        irrelevant: 'Irrelevant risk to health',
      },
      err: {
        handlingTemperature: 'Handling temperature cannot be empty',
        contactFrequency: 'Contact Frequency cannot be empty',
        exposureTime: 'Exposition Time cannot be empty',
      },
    },
    departmentsCopy: {
      title: 'Departments Copy',
      name: 'Name',
      area: 'Area',
      companyId: 'Company',
      companyName: 'Company',
      manager: 'Manager',
      state: {
        name: 'State',
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
      building: 'Building',
      labManager: 'Lab. Manager',
      site: 'Site',
      dvrIt: 'DVR IT',
      notes: 'Notes',
      associationsMessage: 'The following associations will be copied automatically with duplication',
    },
    users: {
      title: 'Users',
      firstName: 'First Name',
      lastName: 'Last Name',
      fullName: 'Name',
      username: 'Username',
      password: 'Password',
      email: 'E-Mail',
      role: 'Role',
      roles: 'Roles',
      department: 'Department',
      machineries: 'Position/Facility',
      roleNames: {
        A: 'Administrator',
        B: 'Chem Manager',
        C: 'Chem Update',
        D: 'Chem View',
        E: 'Batch Manager',
        F: 'SDS View',
        G: 'SDS Annual check'
      },
      reset: 'Password Reset',
      err: {
        firstName: 'Invalid First Name',
        lastName: 'Invalid Last Name',
        username: 'Invalid Username',
        email: 'Invalid E-mail',
        roles: 'At least one role must be selected',
        department: 'Invalid Department',
      },
    },
    logs: {
      title: 'Logs',
      username: 'User',
      timestamp: 'Timestamp',
      description: 'Description',
      from: 'From (dd/mm/yyyy)',
      to: 'To (dd/mm/yyyy)',
    },
    verisk: {
      logtitle: '3E-Verisk Log',
      sendtitle: '3E-Verisk Manual Send',
      timestamp: 'Datetime',
      description: 'Description',
      from: 'From (dd/mm/yyyy)',
      to: 'To (dd/mm/yyyy)',
      sdsuuid: 'SDS ID',
      sdsdocumentuuid: 'SDS Document ID',
      sdsdocumentname: 'SDS Document Name',
      productuuid: 'Product ID',
      product: 'Substance',
      useruuid: 'User ID',
      user: 'User',
      senderror: 'Error Message',
      sendnow: 'Send now',
      sendremove: 'Delete',
    },
    login: {
      username: 'Username',
      password: 'Password',
      submit: 'Sign in to Phoenix',
      error: 'Wrong Username or Password',
      passwordChanged: 'Password successfully changed',
      missingUsernameOrPassword: 'Username and/or Password are missing',
    },
    changePassword: {
      new: 'New Password',
      newRepeat: 'Re-enter new password',
      old: 'Old Password',
      submit: 'Change Password',
      message: 'Your password is expired. Please change your password',
      message2: 'The new password cannot match your username and cannot match your old password',
      notMatching: "The new password don't match",
      length: 'The new password must be at least 8 characters long',
      serverError: 'Error during password change. Check your old password and the requirements for the new one',
    },
    import: {
      submit: 'Import selected files',
      results: 'Import outcome',
    },
    acknowlegmentSDS: {
      acknowledged: 'Acknowledged',
      acknowledger: 'Acknowledger',
      acknowledgedTimestamp: 'Timestamp',
      addTitle: 'Record acknowledgment',
      handleAdd: 'Do you want to record the acknowledgment of the SDS?',
      machineries: "Position/Facility",
    },
    searchSDS: {
      searchField: 'Search for a substance by entering the CAS number or part of the substance code',
      machineries: "Position/Facility",
    },
  },
};

const getLabel = (locale, id) => {
  const msgs = locale ? messages[locale] : messages['it'];
  return dotAccess.get(msgs, id);
};

export default getLabel;



// WEBPACK FOOTER //
// ./src/main/translations/messages.js